import { KontentMultiChoice } from "../types";

export function getMultiChoice(multichoice: KontentMultiChoice<any>) {
  return multichoice?.value[0]?.codename || null;
}
